import { useEffect, useState, FormEvent } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "./AdminLayout";

const FIELDS = [
  ["accept_window_minutes", "Offer accept window (minutes)"],
  ["primary_radius_km", "Primary radius (km)"],
  ["fallback_radius_km", "Fallback radius (km)"],
  ["min_rating_self_employed", "Min rating for self-employed"],
  ["max_strikes", "Max strikes before suspension"],
];

export default function Routing() {
  const [cfg, setCfg] = useState<any>(null);
  useEffect(() => { api.get("/admin/routing-config").then((r) => setCfg(r.data)); }, []);

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const { config_id, updated_at, ...body } = cfg;
      const { data } = await api.put("/admin/routing-config", body);
      setCfg(data); toast.success("Routing config saved");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  if (!cfg) return null;
  return (
    <div data-testid="admin-routing">
      <PageHeader eyebrow="Engine" title="Routing engine" desc="Employed-first job routing. Priority 1 auto-assigns Bhasa employees; Priority 2/3 offer to self-employed via WhatsApp." />
      <div className="grid gap-8 lg:grid-cols-[1fr_1.2fr]">
        <ol className="space-y-3 text-sm">
          {["Match caregivers by city + time + service", "Priority 1 — available employed caregivers (auto-assign if slot clean)", "Priority 2 — self-employed, highest rating in area (WhatsApp offer, accept window)", "Priority 3 — broader radius self-employed", "No match → admin manual resolve"].map((s, i) => (
            <li key={s} className="flex gap-3 rounded-xl border border-brand-line bg-white p-4"><span className="font-heading text-sm font-bold text-brand-gold">0{i + 1}</span><span className="text-brand-navy">{s}</span></li>
          ))}
        </ol>
        <form onSubmit={save} className="space-y-4 rounded-2xl border border-brand-line bg-white p-6 shadow-subtle" data-testid="routing-form">
          <label className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3 text-sm font-medium text-brand-navy">Auto-assign employed caregivers<input type="checkbox" checked={cfg.auto_assign_employed} onChange={(e) => setCfg({ ...cfg, auto_assign_employed: e.target.checked })} className="h-4 w-4" data-testid="routing-auto-assign" /></label>
          {FIELDS.map(([k, label]) => (
            <label key={k} className="block text-sm"><span className="text-brand-slate">{label}</span><input type="number" step="any" value={cfg[k]} onChange={(e) => setCfg({ ...cfg, [k]: Number(e.target.value) })} className="mt-1 h-11 w-full rounded-xl border border-brand-line px-3 outline-none ring-brand-blue/30 focus:ring-4" data-testid={`routing-${k}`} /></label>
          ))}
          <button type="submit" className="h-11 w-full rounded-xl bg-brand-blue text-sm font-semibold text-white hover:bg-brand-blueHover" data-testid="routing-save-button">Save configuration</button>
        </form>
      </div>
    </div>
  );
}
